import { render, staticRenderFns } from "./EurospinProducerInfoTpl.vue?vue&type=template&id=0f6e8174&"
import script from "./EurospinProducerInfoTpl.vue?vue&type=script&lang=js&"
export * from "./EurospinProducerInfoTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports